module.exports = __webpack_public_path__ + "img/pp.7e6b1b43.svg";